module.exports = __webpack_public_path__ + "static/media/forward-emphasis.64a8338a.png";